import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GA_MEASUREMENT_ID, META_PIXEL_ID } from "src/config-global";
import { useConsent } from "./ConsentProvider";
import { syncBarionMarketing, syncGoogle, syncMeta } from "./tracking";

export default function ConsentTracking() {
  const { consent, isDecided } = useConsent();
  const { pathname } = useLocation();
  useEffect(() => {
    syncGoogle(isDecided && consent.analytics, GA_MEASUREMENT_ID, pathname);
    syncMeta(isDecided && consent.marketing, META_PIXEL_ID, pathname);
    syncBarionMarketing(isDecided && consent.marketing);
  }, [consent.analytics, consent.marketing, isDecided, pathname]);
  return null;
}
